import { NavLink } from "react-router-dom";
import { useAuth } from "../../hooks";
import { CgMenuLeft } from "react-icons/cg";
import { useLayout } from "../../context";
import { RiHome5Line, RiRestaurantLine, RiUser3Line } from "react-icons/ri";
import { HiOutlineGiftTop } from "react-icons/hi2";

type Props = {
  handleChange: () => void;
};

export const MobileFooter: React.FC<Props> = () => {
  const { isLoggedIn } = useAuth();
  const { toggleMenu } = useLayout();

  return (
    <>
      <div className="mobile_ftr d-block d-md-none">
        <ul>
          <li>
            <NavLink to={isLoggedIn ? "" : ""}>
              <span
                className="d-flex d-lg-none cursor-pointer"
                onClick={toggleMenu}
              >
                <span className="sidenav-toggler-inner">
                  <CgMenuLeft size={22} />
                </span>
              </span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/">
              <span>
                <RiHome5Line size={22} />
              </span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/menu">
              <span>
                <RiRestaurantLine size={22} />
              </span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/offer-and-rewards">
              <span>
                <HiOutlineGiftTop size={22} />
              </span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/profile">
              <span>
                <RiUser3Line size={22} />
              </span>
            </NavLink>
          </li>

          {/* <li>
            <NavLink to="/cart">
              <span className="position-relative">
                <img src={toAbsoluteUrl("images/m-cart-icon.svg")} alt="" />
                <Badge pill bg="danger" className='fw-light position-absolute' style={{top: "-10px", right: "-10px", opacity: 1}}>{cartQuantity}</Badge>
              </span>
            </NavLink>
          </li> */}
        </ul>
      </div>
    </>
  );
};
